import { Panel } from "../../../../components/panels/Panel";
import { REBA_THRESHOLDS_ADJUSTED } from "../../../../services/ergonomics/ergonomics-service";
import { useMemo } from "react";
import { useErgonomicsContext } from "../../../../contexts/ErgonomicsContext";
import { ErgonomicsNeedZoom } from "../ErgonomicsNeedZoom";

export const ErgonomicsCardSynthesis = () => {

  const { data, flags, checkboxes, zoomDateRange } = useErgonomicsContext();

  const [maxValues, meanValues] = useMemo(() => {
    const maxs = {};
    const means = {};

    for (let n = 1; n <= 13; n++) {
      const stepKey = `step_${n}`;

      if (stepKey in data) {
        let points = data[stepKey].map((point) => point.value);
        points = points.filter((point, index) => flags[index]);
        if (points.length > 0) {
          maxs[n] = Math.max(...points);
          means[n] = points.length ? points.reduce((a, b) => a + b, 0) / points.length : 0;
        }
        else{
          maxs[n] = 0;
          means[n] = 0;
        }
      }
    }

    return [maxs, means];
  }, [data, checkboxes]);

  const getColorClass = (value, warning_thresh, danger_thresh) => {
    if (value >= danger_thresh) return 'text-red-400 font-bold';
    else if (value >= warning_thresh) return 'text-yellow-400';
    else return 'text-green-400';
  };

  return (
    <Panel title="SYNTHESE REBA" height="full">
      {
        zoomDateRange === null ? <ErgonomicsNeedZoom/> :
        <div className='bg-perception-black-800'>
          <table className='w-full'>
            <thead>
            <tr>
              <th className='p-3 text-left bg-perception-gray-800'>Métrique</th>
              <th className='p-3 text-left bg-perception-gray-800'>Valeur moyenne</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td className='p-3'>Position de la nuque</td>
              <td className={`p-3 ${getColorClass(meanValues[1], REBA_THRESHOLDS_ADJUSTED['step_1'][1], REBA_THRESHOLDS_ADJUSTED['step_1'][2])}`}>{Math.round(meanValues[1] * 10) / 10}</td>
            </tr>
            <tr>
              <td className='p-3'>Position du tronc</td>
              <td className={`p-3 ${getColorClass(meanValues[2], REBA_THRESHOLDS_ADJUSTED['step_2'][1], REBA_THRESHOLDS_ADJUSTED['step_2'][2])}`}>{Math.round(meanValues[2] * 10) / 10}</td>
            </tr>
            <tr>
              <td className='p-3'>Position des jambes</td>
              <td className={`p-3 ${getColorClass(meanValues[3], REBA_THRESHOLDS_ADJUSTED['step_3'][1], REBA_THRESHOLDS_ADJUSTED['step_3'][2])}`}>{Math.round(meanValues[3] * 10) / 10}</td>
            </tr>
            <tr>
              <td className='p-3 font-bold'>Score de posture A</td>
              <td className={`p-3 ${getColorClass(meanValues[4], REBA_THRESHOLDS_ADJUSTED['step_4'][1], REBA_THRESHOLDS_ADJUSTED['step_4'][2])}`}>{Math.round(meanValues[4] * 10) / 10}</td>
            </tr>
            <tr>
              <td className='p-3'>Position de l'épaule</td>
              <td className={`p-3 ${getColorClass(meanValues[7], REBA_THRESHOLDS_ADJUSTED['step_7'][1], REBA_THRESHOLDS_ADJUSTED['step_7'][2])}`}>{Math.round(meanValues[7] * 10) / 10}</td>
            </tr>
            <tr>
              <td className='p-3'>Position du coude</td>
              <td className={`p-3 ${getColorClass(meanValues[8], REBA_THRESHOLDS_ADJUSTED['step_8'][1], REBA_THRESHOLDS_ADJUSTED['step_8'][2])}`}>{Math.round(meanValues[8] * 10) / 10}</td>
            </tr>
            <tr>
              <td className='p-3'>Position du poignet</td>
              <td className={`p-3 ${getColorClass(meanValues[9], REBA_THRESHOLDS_ADJUSTED['step_9'][1], REBA_THRESHOLDS_ADJUSTED['step_9'][2])}`}>{Math.round(meanValues[9] * 10) / 10}</td>
            </tr>
            <tr>
              <td className='p-3 font-bold'>Score de posture B</td>
              <td className={`p-3 ${getColorClass(meanValues[10], REBA_THRESHOLDS_ADJUSTED['step_10'][1], REBA_THRESHOLDS_ADJUSTED['step_10'][2])}`}>{Math.round(meanValues[10] * 10) / 10}</td>
            </tr>
            <tr>
              <td className='p-3 font-bold'>Score de posture C</td>
              <td className={`p-3 ${getColorClass(meanValues[13], REBA_THRESHOLDS_ADJUSTED['step_13'][1], REBA_THRESHOLDS_ADJUSTED['step_13'][3])}`}>{Math.round(meanValues[13] * 10) / 10}</td>
            </tr>
            </tbody>
          </table>
        </div>
      }
    </Panel>
  );
};